'use client'

import { useEffect } from 'react'
import { isSensitiveTelemetryPath } from './sensitiveTelemetryPaths'

export function HyperDXBrowserInit() {
  useEffect(() => {
    // Both routes carry one-time authorization tokens in the URL. HyperDX session
    // replay records `window.location.href`, so telemetry must stay disabled there.
    if (isSensitiveTelemetryPath(window.location.pathname)) return

    const apiKey = process.env.NEXT_PUBLIC_HYPERDX_API_KEY
    if (!apiKey) return
    import('@hyperdx/browser').then(({ default: HyperDX }) => {
      HyperDX.init({
        apiKey,
        service: 'algoacademy-browser',
        url: process.env.NEXT_PUBLIC_HYPERDX_OTLP_ENDPOINT,
        maskAllInputs: true,
        maskAllText: false
      })
    })
  }, [])

  return null
}
